import QRCode from 'qrcode'
import {roles,friends} from '../config/'
export function GetShareImage(code) {
    return new Promise(async resolve => {
        const shareurl = `https://actblood.web.sdo.com/project/2022/1201_Game/index.html?helpcode=${code}#/myshare`,
            img = await QRCode.toDataURL(shareurl);
        const bgImage = new Image(),
            codeImage = new Image();
        codeImage.crossOrigin = "*";
        codeImage.src = img;
        codeImage.width = 157;
        codeImage.height = 157;
        bgImage.crossOrigin = "*";
        bgImage.src = 'https://static.web.sdo.com/xuezu/pic/20221201_Game/sharePic.jpg';
        codeImage.addEventListener('load', () => {
            bgImage.addEventListener('load', () => {
                const canvas = document.createElement('canvas'),
                    ctx = canvas.getContext('2d');
                canvas.width = 640;
                canvas.height = 1140;
                ctx.drawImage(bgImage, 0, 0, 640, 1140);
                ctx.drawImage(codeImage, 43, 880, 157, 157);
                resolve(canvas.toDataURL('image/jpeg'))
            })
        })
    })
}


export function GetGroups(items) {
    let arrs = [];
    const rewards = items;
    const groups = _.groupBy(rewards, item => item.itemid);
    const arr = [];
    for (const key in groups) {
        const items = groups[key];
        let counts = 0;
        items.map(r => {
            counts += r.itemcount
        })
        const item = {
            itemid: key * 1,
            counts,
            isitem: items[0].isitem,
        }
        arrs.push(item);
    }
    arrs = _.sortBy(arrs, r => r.isitem)
    return arrs;
}

export function GetFriends(roles,gets){
    const res = [...friends];
    res.map(item=>{
        const list=[];
        item.roles.map(r=>{
            const info = {
                roleid:r,
                isget:roles.includes(r)
            }
            list.push(info);
        })
        item.list=list;
        const full = item.list.every(item=>item.isget===true);
        if(full){
            if(gets.includes(item.rewardid)){
                item.isget=2;// 已领取
            }else{
                item.isget=1;// 待领取
            }
        }else{
            item.isget=0;//未达成
        }
    })
    return res;
}